import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import log from '@atlassian/jira-common-util-logging/src/log';
import { REFRESH_SOURCE_FAILURE } from '../../model/constants';
import type { CardList } from '../../model/types';
import sprintCreateService from '../../services/sprint-create';
import { refreshDataRequest } from '../../state/actions/app';
import {
	SPRINT_CREATE_REQUEST,
	sprintCreateFailure,
	sprintCreateSuccess,
	type SprintCreateRequestAction,
} from '../../state/actions/sprints/create';
import { getBaseUrl, getRapidViewId } from '../../state/selectors/app';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const sprintCreateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SPRINT_CREATE_REQUEST).mergeMap((action: SprintCreateRequestAction) => {
		const {
			meta: {
				optimistic: { id: optimisticId },
				analyticsEvent,
			},
			payload: { temporaryCardListId },
		} = action;

		const state = store.getState();
		const baseUrl = getBaseUrl(state);
		const rapidViewId = getRapidViewId(state);

		return sprintCreateService(baseUrl, rapidViewId)
			.map((sprint: CardList) =>
				sprintCreateSuccess(sprint, temporaryCardListId, optimisticId, analyticsEvent),
			)
			.catch((error) => {
				log.safeErrorWithoutCustomerData(
					'backlog.sprint-create.failure',
					'Failed to create sprint',
					error,
				);
				return Observable.from([
					sprintCreateFailure(temporaryCardListId, optimisticId, analyticsEvent),
					refreshDataRequest(REFRESH_SOURCE_FAILURE),
				]);
			});
	});
